<template>
  <div class="space-y-3 rounded-xl border border-gray-200 bg-white px-4 py-3" data-test="field-palette">
    <div v-for="group in groups" :key="group.key">
      <p class="mb-1.5 text-xs font-bold uppercase tracking-wider text-gray-500">{{ t(`group.${group.key}`) }}</p>
      <div class="flex flex-wrap gap-1.5">
        <button
          v-for="field in group.fields"
          :key="field"
          type="button"
          class="rounded-full border px-3 py-1 text-xs font-semibold disabled:cursor-not-allowed disabled:opacity-40"
          :class="
            suggestedFields.includes(field)
              ? 'border-yellow-300 bg-yellow-50 text-yellow-900 hover:bg-yellow-100'
              : 'border-gray-200 bg-white text-gray-800 hover:border-primary hover:bg-primary-light'
          "
          :disabled="usedFields.includes(field)"
          :data-test="`palette-${field}`"
          @click="$emit('add', field)"
        >
          {{ t(`claim.declaration_field.${field}`) }}
          <span v-if="isMissingFile(field)" class="ml-0.5 font-normal text-yellow-800">{{ t("missing") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { FIELD_GROUPS, FILE_FIELDS, currentValue, isRequestable } from "./complementFields";

export default {
  name: "ClaimComplementFieldPalette",

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    declaration: {
      type: Object,
      default: null,
    },
    // Champs déjà dans la demande : grisés pour ne pas les demander deux fois.
    usedFields: {
      type: Array,
      default: () => [],
    },
    // Champs proposés par l'agent : un retiré se repère pour être rajouté facilement.
    suggestedFields: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["add"],

  computed: {
    // Un groupe sans champ proposable disparaît plutôt que d'afficher un titre vide.
    groups() {
      return FIELD_GROUPS.map((group) => ({
        key: group.key,
        fields: group.fields.filter(
          (field) => this.suggestedFields.includes(field) || isRequestable(this.declaration, field),
        ),
      })).filter((group) => group.fields.length > 0);
    },
  },

  methods: {
    isMissingFile(field) {
      return FILE_FIELDS.has(field) && currentValue(this.declaration, field).length === 0;
    },
  },
};
</script>

<i18n src="./ClaimComplementFieldPalette.i18n.json"></i18n>
